export default __webpack_public_path__ + "static/media/fail.d412e479.png";